import { render, staticRenderFns } from "./ItemsPerPageSelector.vue?vue&type=template&id=b6067f3a"
import script from "./ItemsPerPageSelector.vue?vue&type=script&lang=js"
export * from "./ItemsPerPageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports